<template>
  <a href="#" class="alt-font" @click.prevent="downloadPdf">&darr; Download PDF</a>
</template>

<script>
import * as api from "../lib/api";
import FF_PATTERNS from "../../universal/filzfelt/patterns";
import SP_PATTERNS from "../../universal/spinneybeck/patterns";

const INCHES_IN_METER = 39.3700787;

export default {
  computed: {
    design() {
      return this.$store.state.design;
    },
    width() {
      return this.$store.getters.width;
    },
    height() {
      return this.$store.getters.height;
    },
    brand() {
      return this.$store.getters.brand;
    },
    metric() {
      return this.$store.getters.metric;
    },
    tileDimensions() {
      const pattern =
        this.brand === "filzfelt"
          ? FF_PATTERNS[this.design.pattern]
          : SP_PATTERNS[this.design.pattern];

      return this.metric
        ? pattern && pattern.dimensions && pattern.dimensions.m
        : pattern && pattern.dimensions && pattern.dimensions.i;
    }
  },
  methods: {
    downloadPdf() {
      const data = Object.assign(
        {
          dimensions: `W ${this.width} x H ${this.height}`,
          ...(this.tileDimensions && { tileDimensions: this.tileDimensions })
        },
        this.design
      );

      api
        .pdf(data)
        .then(pdf => {
          const ie = navigator.userAgent.match(/MSIE\s([\d.]+)/);
          const ie11 =
            navigator.userAgent.match(/Trident\/7.0/) &&
            navigator.userAgent.match(/rv:11/);
          const ieEDGE = navigator.userAgent.match(/Edge/g);
          const ieVer = ie ? ie[1] : ie11 ? 11 : ieEDGE ? 12 : -1;

          if (ie && ieVer < 10) {
            console.log("No blobs on IE ver<10");
            return;
          }

          const blob = new Blob([pdf], { type: "application/pdf" });
          const timestamp = new Date().getTime().toString();
          const fileName = `${this.brand}-design-spec_${timestamp}.pdf`;

          if (ieVer > -1) {
            window.navigator.msSaveBlob(blob, fileName);
          } else {
            var downloadLink = document.createElement("a");
            downloadLink.download = fileName;
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.onclick = function(e) {
              document.body.removeChild(e.target);
            };
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }

          // GA: track PDF download
          if (ga) {
            ga("send", {
              hitType: "event",
              eventCategory: "PDF",
              eventAction: "download",
              eventLabel: fileName
            });
          }
        })
        .catch(err => console.error(err));
    }
  }
};
</script>



// WEBPACK FOOTER //
// DownloadPdf.vue?12a935c4